import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Missouri Non-Profit State Filing Requirements & Deadlines"
          description="Learn Missouri’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state. "
          keywords=" "
          canonical="nonprofit-taxes/missouri-state-filing-requirements/"
          // jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-mo-landing-img.webp" />
                <source srcSet="/assets/images/1099-mo-landing-img.png" />
                <img
                  src="/assets/images/1099-mo-landing-img.png"
                  alt="Missouri State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Missouri State </span>
                </span>{' '}
                Filing
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                If you&apos;re operating a nonprofit in Missouri, you must stay
                compliant with state-specific filing and registration
                requirements.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=missouri`}
                  >
                    Start E-filing Now
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-mo-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-mo-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-mo-landing-img-sm.png"
                  alt="Missouri State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Missouri are required to complete several forms as
            part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Attorney General Forms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Tax Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.mo.gov/cmsimages/business/corp41.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Article of Incorporation
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.mo.gov/fileonline/reports"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Annual Report Filing
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.mo.gov/CMSImages/Business/corp53a.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Corp 53A - Articles of Amendment for a Nonprofit
                                Corporation
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.mo.gov/CMSImages/Business/corp52.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                CORP 52 - Articles of Incorporation of a
                                Nonprofit Corporation
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://ago.mo.gov/wp-content/uploads/charityinitialCH.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Charitable Organization - Initial Registration
                                Statement
                              </Link>
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://dor.mo.gov/forms/1746.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 1746 - Missouri Sales or Use Tax Exemption
                                Application
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://dor.mo.gov/pdf/MOREV1746R.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 1746R - Missouri Sales/Use Tax Exemption
                                Renewal
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1023 (Application for Recognition of
                                Exemption Under Section 501(c)(3) of the
                                Internal Revenue Code):
                              </span>{' '}
                              For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1024 (Application for Recognition of
                                Exemption Under Section 501(a) or Section 521 of
                                the Internal Revenue Code):
                              </span>{' '}
                              For other types of nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 990 (Return of Organization Exempt From
                                  Income Tax):
                                </span>
                              </Link>{' '}
                              Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                The process of establishing a non-profit in Missouri involves
                several key steps, each with specific filing requirements.
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Choose a Name
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Select a unique, distinguishable name that includes a
                    corporate suffix (e.g., Inc., Corp., Ltd.). Check
                    availability through the Missouri Secretary of State’s
                    online database.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    File Articles of Incorporation
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Submit Articles of Incorporation to the Missouri Secretary
                    of State. This document legally establishes your non-profit.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Obtain an EIN
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Apply for a Federal Employer Identification Number (EIN)
                    from the IRS.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Apply for State Tax Exemptions
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    File Form 1746 with the Missouri DOR to request sales/use
                    tax exemption.
                  </Typography>
                </li>{' '}
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Register for Charitable Solicitation (if applicable)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Non-profits soliciting donations must register with the
                    Missouri Attorney General’s Office unless exempt (e.g.,
                    religious or educational organizations).
                  </Typography>
                </li>{' '}
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-mo-img.webp" />
                <source srcSet="/assets/images/who-file-mo-img.png" />
                <img
                  src="/assets/images/who-file-mo-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#fff',
                  maxWidth: 800,
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Missouri</span>,
                    organizations must:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li svg': { float: 'left', fontSize: 27 },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Must secure federal 501(c)(3) recognition.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply for Sales tax exemption requires application to the{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Missouri Department of Revenue
                      </span>{' '}
                      with IRS letter.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Register with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Missouri Attorney General’s Office
                      </span>{' '}
                      if soliciting donations
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply with the local assessor in the county where the
                      property is located. Must prove the property is used
                      exclusively for charitable purposes.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <span style={{ fontWeight: 600 }}> Annual Filing:</span>{' '}
                      File Form 990 with the IRS.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in Missouri:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Upon formation of the non-profit.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Initial Report (Secretary of State)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Within 30 days of filing the Articles of
                          Incorporation.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Annual Registration Report (Secretary of State)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          By August 31st each year. A late filing penalty of $15
                          is charged for every 30 days of delinquency.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Attorney General Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Charitable Organization Initial Registration Statement
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Before soliciting donations in Missouri incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Tax Forms Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1746 - Missouri Sales or Use Tax Exemption
                          Application
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Monthly, quarterly, or annual depending on sales
                          volume
                          <Box
                            component="ul"
                            sx={{ mb: 2, '& li': { mb: 1.5 } }}
                          >
                            <li>
                              <span style={{ fontWeight: 600 }}> Monthly:</span>{' '}
                              Due 20th of the following month
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Quarterly:
                              </span>{' '}
                              Due last day of month following quarter end
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}> Annual:</span>{' '}
                              Due January 31 for the previous calendar year
                            </li>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=missouri`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Missouri, organizations must
            file the Articles of Organization and pay the filing fee of $25.
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Name Availability
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Before filing your Articles of Incorporation, check with the
                    Missouri Secretary of State to ensure your desired
                    organization name is available and not already in use.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Drafting Articles of Incorporation
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    The articles must include essential information, such as the
                    organization&apos;s name, purpose, registered agent&apos;s
                    name and address, initial board of directors, and a
                    statement of irrevocability (that the organization&apos;s
                    assets will be distributed to another 501(c)(3) organization
                    upon dissolution).
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Appointing a Registered Agent
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    A registered agent is responsible for receiving legal and
                    official notices on behalf of your organization. The
                    registered agent must have a physical street address in
                    Missouri.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Filing the Articles
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    File the Articles of Incorporation with the Missouri
                    Secretary of State, along with the required filing fee of
                    $25.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Obtaining an EIN (Employer Identification Number)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Apply for an EIN from the IRS. This is your
                    organization&apos;s federal tax identification number and is
                    required for opening bank accounts and filing federal tax
                    forms.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    6. Applying for 501(c)(3) Status (Optional)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    File Form 1023 or 1023-EZ with the IRS to obtain federal
                    tax-exempt status. This is a crucial step for most
                    non-profits.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Filing Annual Report
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    All non-profit corporations registered in Missouri are
                    mandated to file an Annual Registration Report with the
                    Secretary of State each year.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Provide information such as your business identification
                    number, business name, address, and details of your officers
                    and directors.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Charitable Solicitation Registration and Annual Reporting
                    with the Attorney General
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    As previously mentioned, most non-profits intending to
                    solicit donations in Missouri must initially register with
                    the Attorney General&apos;s Office. Beyond the initial
                    registration, these organizations are also required to file
                    an annual report with the Attorney General.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Maintain Compliance with IRS
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    File the annual Form 990 series (990, 990-EZ, 990-N, or
                    990-PF) with the IRS. Failure to do so for three consecutive
                    years can result in automatic revocation of federal
                    tax-exempt status.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Maintain Accurate Records
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Keep meticulous records of all financial transactions,
                    donations, and activities. This will be essential for
                    preparing annual reports and complying with any audits or
                    inquiries.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Charitable Solicitation Registration (If Applicable)
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0 }}>
                    If you plan to solicit donations, register with the Missouri
                    Attorney General&apos;s Office, submitting the required
                    application and supporting documentation.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Professional IRS Filing Platform
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone offers nonprofits dependable and accurate e-filing services.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=missouri`}
          >
            E-File Now
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How do I change our registered agent?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    You can change your registered agent by filing a
                    &quot;Statement of Change of Registered Agent/Office&quot;
                    with the Missouri Secretary of State.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Are audits required for Missouri nonprofits?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      In Missouri, audits are generally not required for
                      nonprofits unless they receive federal funds exceeding
                      $750,000 annually, triggering a Single Audit requirement,
                      or if required by specific contracts or state regulations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What happens if I miss the annual report filing deadline?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Your organization will be listed as &quot;not in good
                      standing.&quot; If you fail to file for an extended period
                      (typically two consecutive years), the Secretary of State
                      may administratively dissolve your nonprofit corporation.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I reserve my nonprofit&apos;s name in Missouri before
                  filing formation documents?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b>Yes</b>, you can reserve your Missouri nonprofit&apos;s
                      name before filing formation documents with the Missouri
                      Secretary of State, by submitting an Application for
                      Reservation of Name (Form BE-1) and paying a $25 fee.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What is the minimum number of directors required for a
                  Missouri nonprofit?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Missouri law requires at least <b>three directors</b> for
                      nonprofit corporations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://www.sos.mo.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Missouri Secretary of State
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.sos.mo.gov/business"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Missouri Secretary of State — Business Services
                          Division
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://ago.mo.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Missouri Attorney General&apos;s Office
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://dor.mo.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Missouri Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Services
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
